import * as preact from 'preact';
import { useMemo } from 'preact/hooks';
import { ToolWrapper, Error, getBaseUrl } from './tools-common';
import { useFetch } from '../utils/async';
import { uniqueId } from '../utils/unique-id';

export function DirectoryTool({ active }) {
	let dataUrl = `${getBaseUrl()}/wp-json/site-data/sidebar/directory/`;
	let headers = { Accept: 'application/json' };
	let { data, error, isLoading } = useFetch(dataUrl, { headers });

	let departments = data?.directory_tool?.departments || [];
	let majors = data?.directory_tool?.majors || [];

	return (
		<ToolWrapper active={active} heading="Directory Search">
			<form
				className="directory-search"
				role="search"
				method="GET"
				action="https://www.stolaf.edu/directory/search"
			>
				<label className="directory-search__label" htmlFor="query">
					Find faculty, staff or students
				</label>

				<input
					className="tools-nav--focusable directory-search__input input--full-width"
					id="query"
					name="query"
					placeholder="search by name"
				/>

				{error ? <Error error={error} /> : null}

				<DirectorySelect
					items={departments}
					label="department"
					name="department"
					loading={isLoading}
				/>

				<DirectorySelect
					items={majors}
					label="major"
					name="major"
					loading={isLoading}
				/>

				<button
					className="btn btn--xs input--full-width tools-nav--focusable"
					type="submit"
				>
					Search →
				</button>
			</form>
		</ToolWrapper>
	);
}

function DirectorySelect({ items, label, name, loading }) {
	let id = useMemo(() => `${name}-${uniqueId()}`, [name]);

	return (
		<>
			<label className="directory-search__label" htmlFor={id}>
				By {label}
			</label>

			<select
				id={id}
				className="tools-nav--focusable directory-search__select input--full-width"
				name={name}
				disabled={loading}
			>
				{loading ? (
					<option selected value="">
						Loading {label}s…
					</option>
				) : items.length === 0 ? (
					<option selected disabled value="">
						No {label}s found.
					</option>
				) : (
					<>
						<option value="">Select a {label}</option>
						{items.map(item => (
							<option value={item.value}>{item.name}</option>
						))}
					</>
				)}
			</select>
		</>
	);
}
